import React from 'react';
import { IIconProps } from './utils';

export const ThumbUp = ({
  fill = 'currentColor',
  height,
  size = 20,
  width,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height || size}
    viewBox="0 0 15 14"
    width={width || size}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.9258 6.86751L13.7368 10.8511C13.297 12.3244 11.9478 13.3333 10.4174 13.3333L4.58333 13.3332C4.35321 13.3332 4.16667 13.1467 4.16667 12.9166V5.01018C4.16667 4.79124 4.33874 4.61477 4.54824 4.55119C4.81933 4.46892 5.06879 4.32034 5.27268 4.11542L6.25238 3.13076C6.69652 2.68436 7.0116 2.12504 7.16394 1.5126L7.26764 1.0957C7.3309 0.841354 7.46176 0.609068 7.64621 0.423682C8.20827 -0.141227 9.11954 -0.141227 9.6816 0.423681L9.77027 0.512798C10.1589 0.903394 10.3151 1.47028 10.1818 2.00618L9.65895 4.10827C9.59357 4.37113 9.79243 4.62551 10.0633 4.62551H13.2661C14.4268 4.62551 15.2593 5.75011 14.9258 6.86751Z"
      fill={fill}
    />
    <path
      d="M0 5.49623V12.4625C0 12.9434 0.387895 13.3333 0.866388 13.3333H2.08333C2.31345 13.3333 2.5 13.1467 2.5 12.9166V5.04211C2.5 4.812 2.31345 4.62545 2.08333 4.62545H0.866388C0.387895 4.62545 0 5.01531 0 5.49623Z"
      fill={fill}
    />
  </svg>
);
